/*import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function getSettings(token) {
  const settingsUrl = `${API_URL}/settings`;
  const headers = {
    authorization: token,
  };
  const response = await axios.get(settingsUrl, { headers });
  return response.data;
}
*/

import axios from "axios";

const SETTINGS_URL =
  `${process.env.REACT_APP_API_URL}/api/settings` ||
  "http://localhost:3001/api/settings";

export async function getSettings(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL, { headers });
  return response.data;
}

export async function updateSettings(newData, token) {
  const headers = { authorization: token };
  const response = await axios.patch(SETTINGS_URL, newData, { headers });
  return response.data;
}
